// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyCSrH1hgSnf2ZPDaPfeUuMHvddDcBNAYZs",
    authDomain: "centro-de-conciliacion.firebaseapp.com",
    projectId: "centro-de-conciliacion",
    storageBucket: "centro-de-conciliacion.firebasestorage.app",
    messagingSenderId: "356555725525",
    appId: "1:356555725525:web:d2096acf5ea2cbd460a05c",
    measurementId: "G-J7KMDNKXDE"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)